import { Component } from 'react';
import { C } from '../constants';

// Red de la carga diferida. Con las pantallas en archivos separados aparece un
// modo de falla que antes no existía: alguien con el portal abierto mientras se
// publica una versión nueva pide un archivo que ya no está en el servidor, y sin
// esto vería una pantalla en blanco. Recargar trae la versión nueva y sigue
// trabajando. La bandera en sessionStorage evita el bucle de recargas si la
// falla no era esa: a la segunda se le muestra el aviso y un botón.
const CLAVE = 'innovalab_recarga_chunk';

function esFalloDeCarga(error) {
  const txt = `${error?.name || ''} ${error?.message || ''}`;
  return /Loading chunk|ChunkLoadError|Loading CSS chunk|dynamically imported module/i.test(txt);
}

const BOTON = {
  background: C.teal, color: '#fff', border: 'none', borderRadius: 6,
  padding: '10px 26px', fontSize: 12, letterSpacing: 1, cursor: 'pointer', fontWeight: '600',
};

export default class LimiteCarga extends Component {
  constructor(props) { super(props); this.state = { fallo: false }; }

  static getDerivedStateFromError() { return { fallo: true }; }

  componentDidCatch(error) {
    if (esFalloDeCarga(error)) {
      let yaRecargo = false;
      try { yaRecargo = sessionStorage.getItem(CLAVE) === '1'; } catch {}
      if (!yaRecargo) {
        try { sessionStorage.setItem(CLAVE, '1'); } catch {}
        window.location.reload();
        return;
      }
    }
    console.error('Pantalla no cargó:', error);
  }

  componentDidMount() { try { sessionStorage.removeItem(CLAVE); } catch {} }

  render() {
    if (!this.state.fallo) return this.props.children;
    return (
      <div style={{ padding:'40px 24px', textAlign:'center', color:C.navy }}>
        <div style={{ fontSize:13, fontWeight:'700', marginBottom:8 }}>No se pudo abrir esta pantalla</div>
        <div style={{ fontSize:12, color:C.muted, marginBottom:18 }}>
          Suele pasar cuando se publicó una versión nueva mientras tenías el portal abierto.
        </div>
        <button onClick={() => window.location.reload()} style={BOTON}>RECARGAR</button>
      </div>
    );
  }
}

